module.exports = __webpack_public_path__ + "static/media/Label_Google_Play.b3c0c609.png";